import { useQuery } from "@tanstack/react-query";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { axInst } from "../Login/Service";
import WaterMark from "../WaterMark/WaterMark";
import ComplaintImage from "../../Artifacts/ComplaintDetail.png";

const fetchComplaint_Details = async (data) => {
  try {
    const res = await axInst.post("/complaints/complain_details", data);
    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch detailed data");
  }
};

const Complaint_Details_Modal = ({ closeModal, srNo }) => {
  const { data: filtersComplaintData, submitted } = useSelector(
    (state) => state.filtersComplaint
  );

  const {
    data: complaintData,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ["complaintdetailed", submitted, srNo],
    queryFn: () =>
      fetchComplaint_Details({ sr_no: srNo, ...filtersComplaintData }),
    initialData: [],
    cacheTime: 0,
    staleTime: 0,
  });

  const [complaintDetails, setComplaintDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getComplaintDetails = async () => {
      try {
        const details = await fetchComplaint_Details({
          sr_no: srNo,
          ...filtersComplaintData,
        });
        setComplaintDetails(details.complain_details[0] || null);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    getComplaintDetails();
  }, [srNo, filtersComplaintData]);

  return (
    <div className="modal-overlay">
      <WaterMark />
      <div className="modal p-8">
        <div className="flex justify-end">
          <button onClick={closeModal} className="close-button">
            &times;
          </button>
        </div>
        {loading ? (
          <div>Loading...</div>
        ) : isError ? (
          <div>Error: {error.message}</div>
        ) : !complaintDetails ? (
          <div>Data is not available</div>
        ) : (
          <>
            <div className="flex gap-5 items-center">
              <img
                src={ComplaintImage}
                alt="image"
                className="self-center justify-self-center w-14 h-14"
              />
              <div className="text-left">
                <h2 className="text-[#FF0000] text-2xl font-semibold">
                  Complaint + {srNo}
                </h2>
                <p className="text-[#393939] text-xl font-bold">
                  Open for Days
                </p>
              </div>
            </div>
            <div className="mt-4">
              <table>
                <tbody>
                  <tr>
                    <td className="px-6 py-2 text-gray-900 text-left">
                      Region
                    </td>
                    <td className="px-6 py-2 text-gray-900 text-center">
                      {complaintDetails.REGION}
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-2 text-gray-900 text-left">
                      Raised Date
                    </td>
                    <td className="px-6 py-2 text-gray-900 text-center">
                      {complaintDetails.OPEN_DATE}
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-2 text-gray-900 text-left">
                      Origin
                    </td>
                    <td className="px-6 py-2 text-gray-900 text-center">
                      {complaintDetails.X_ATTRIB_04}
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-2 text-gray-900 text-left">Mode</td>
                    <td className="px-6 py-2 text-gray-900 text-center">
                      {complaintDetails.COMM_METHOD_CD}
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-2 text-gray-900 text-left">
                      Primary Complaint Area
                    </td>
                    <td className="px-6 py-2 text-gray-900 text-center">
                      {complaintDetails.AREA}
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-2 text-gray-900 text-left">
                      Sub Area
                    </td>
                    <td className="px-6 py-2 text-gray-900">
                      Sub Area Placeholder
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-2 text-gray-900 text-left">
                      Description
                    </td>
                    <td className="px-6 py-2 text-gray-900">
                      {complaintDetails.X_ATTRIB_47}
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-2 text-gray-900 text-left">
                      Sub Status
                    </td>
                    <td className="px-6 py-2 text-gray-900">
                      {complaintDetails.SR_STAT_ID}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Complaint_Details_Modal;
